export default "__VITE_ASSET__83013e48__"